import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import categoriesReducer from '../modules/categories';
import tagsReducer from '../modules/tags';
import homeProductsReducer from '../modules/homeProducts';
import productsReducer from '../modules/products';
import productsSearchReducer from '../modules/productsSearch';
import singleProductReducer from '../modules/singleProduct';
import cartReducer from '../modules/cart';
import userReducer from '../modules/user';
import newsletterReducer from '../modules/newsletter';
import ordersReducer from '../modules/orders';
import singleOrderReducer from '../modules/singleOrder';
import storeReducer from '../modules/store';
import checkoutReducer from '../modules/checkout';
import citiesReducer from '../modules/cities';
import pudoReducer from '../modules/pudo';
import countriesReducer from '../modules/countries';
import postsReducer from '../modules/posts';
import singlePostReducer from '../modules/singlePost';
import singlePageReducer from '../modules/singlePage';
import addedToCartReducer from '../modules/addedToCart';
import contactFormReducer from '../modules/contactForm';
import showHeaderMenuReducer from '../modules/showHeaderMenu';
import couponsReducer from '../modules/coupons';
import symptomsReducer from '../modules/symptoms';
import fideltyCardReducer from '../modules/fideltyCard';
import pagesReducer from '../modules/pages';
import recommendedItemsReducer from '../modules/recommendedItems';
import layoutReducer from '../modules/layout';

const rootReducer = combineReducers({
  form: formReducer,
  categories: categoriesReducer,
  tags: tagsReducer,
  homeProducts: homeProductsReducer,
  products: productsReducer,
  productsSearch: productsSearchReducer,
  singleProduct: singleProductReducer,
  cart: cartReducer,
  user: userReducer,
  newsletter: newsletterReducer,
  orders: ordersReducer,
  singleOrder: singleOrderReducer,
  store: storeReducer,
  checkout: checkoutReducer,
  cities: citiesReducer,
  countries: countriesReducer,
  posts: postsReducer,
  singlePost: singlePostReducer,
  singlePage: singlePageReducer,
  addedToCart: addedToCartReducer,
  contactForm: contactFormReducer,
  showHeaderMenu: showHeaderMenuReducer,
  coupons: couponsReducer,
  pudo: pudoReducer,
  symptoms: symptomsReducer,
  card: fideltyCardReducer,
  pages: pagesReducer,
  recommendedItems: recommendedItemsReducer,
  layout: layoutReducer,
});

export default rootReducer;
